<script>
  import { isReady, words } from '../data/dataAPI';
  import { scaleLinear } from 'd3-scale';
  import { extent } from 'd3-array';

  let width;

  $: sizeRange = width < 500 ? [10, 32] : width > 960 ? [14, 96] : [14, 72];
  $: scaleSize = scaleLinear()
    .range(sizeRange)
    .domain(extent($words, d => d.value));
</script>

<style type="text/scss">
  @import './styles/theme.scss';

  .words {
    @include fluid-space(margin-top, $sp-medium);
    @include fluid-space(margin-bottom, $sp-xlarge);
  }
  .word {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    padding: 0.15em 0.35em;
    margin: 3px;
    display: inline-flex;
    align-items: center;
  }
  // .word__name {
  //   margin: 0 0.05em 0 0.25em;
  // }
  .word__count {
    @include fluid-font-size($fs-small);
    color: $c-gray-2;
    margin-left: 0.5em;
  }
</style>

{#if $isReady}
  <div class="words" bind:clientWidth={width}>
    {#each $words as d}
      <span class="word" style={`font-size:${scaleSize(d.value)}px`}>
        <span class="word__name">{d.word}</span>
        <span class="word__count">({d.value})</span>
      </span>
    {/each}
  </div>
{:else}
  <p>Loading...</p>
{/if}
